import { Grid } from "@mui/material";
import { useState } from "react";
import { CustomButton } from "../../../../components/customButton/CustomButton";
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { CONSULTAR_HC_PACIENTE } from "../../../../data/graphQL/queries/SoporteHC/consultas";
import { useQueryHandler } from "../../hooks/useQueryHandler";

export default function ConsultarHCPacienteForm() {
    const inputFields = [
        {
            name: 'idEvaluacion',
            type: 'int',
            displayName: 'Evaluación',
            size: 2,
            required: true,
            placeholder: 'Ingrese ID Evaluación'
        },
    ];

    const [result, setResult] = useState('');

    const { values, handleChange, handleSubmit, loading } =
        useQueryHandler({
            initialValues: {
                idEvaluacion: '',
            },
            query: CONSULTAR_HC_PACIENTE,
            onSuccess: (data) => {
                const { idPaciente, nombre, apellido } = data?.evaluacionSoporteHC?.idPacienteNavigation || {};
                setResult(<span>HC (del paciente {nombre} {apellido}): <strong>{idPaciente}</strong></span>);
            },
            handleChangeCallback: () => {
                setResult('');
            }
        });

    return (
        <form onSubmit={(e) => handleSubmit(e)}>
            <Grid container spacing={2}>
                {inputFields.map(({ size, ...input }) => (
                    <Grid key={input.name} size={{ xs: 12, sm: (size || 12) }} className="form-field-wrapper">
                        <RenderInputByTypeMobile
                            input={input}
                            value={values[input.name]}
                            handleChange={handleChange}
                        />
                    </Grid>
                ))}
                <Grid size={3}>
                    <CustomButton
                        variant='outlined'
                        isLoading={loading}
                        onClick={handleSubmit}
                    >Aceptar</CustomButton>
                </Grid>
                {result && <Grid size={12}>{result}</Grid>}
            </Grid>
            <button type="submit" hidden />
        </form>
    )
}
